export default __webpack_public_path__ + "static/media/chevron_down.77fe6393.svg";